/* ============================================================
   OCD mobile sticky add-to-cart bar
   Shows once the shopper scrolls past the buy panel.
   Uses a simple scroll-position check (reliable on mobile).
   ============================================================ */
(function () {
  'use strict';

  if (window.innerWidth > 749) return;           // mobile only
  var bar = document.querySelector('[data-ocd-sticky]');
  if (!bar) return;

  var btn = bar.querySelector('.ocd-sticky__btn');
  var mode = bar.getAttribute('data-mode');       // 'add' or 'scroll'
  var panel = document.querySelector('.product__info-container')
           || document.querySelector('product-info')
           || document.querySelector('.product');

  function panelBottom() {
    if (!panel) return 600;                        // fallback trigger point
    var rect = panel.getBoundingClientRect();
    return rect.bottom + window.pageYOffset;       // absolute Y of panel bottom
  }

  var triggerY = panelBottom();

  function onScroll() {
    // recompute occasionally in case layout shifted (images loading, etc.)
    var scrolled = window.pageYOffset || document.documentElement.scrollTop;
    if (scrolled > triggerY - window.innerHeight + 40) {
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }

  // recompute trigger point after load and on resize
  window.addEventListener('load', function () { triggerY = panelBottom(); onScroll(); });
  window.addEventListener('resize', function () { triggerY = panelBottom(); onScroll(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (btn) {
    btn.addEventListener('click', function () {
      if (mode === 'add') {
        var atc = document.querySelector('.product-form__submit');
        if (atc) atc.click();
      } else {
        var target = panel || document.querySelector('product-info');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
})();